import React from "react";

import "./floating-menu.css";

/** Drop DownMenu used at HamburgerMenu and Elipsis in Mobile View */
export function FloatingMenu({ children }: { children: React.ReactNode }) {
	return <div className="floating-menu">{children}</div>;
}
